import './bootstrap';
import './components/date-picker';
import './components/checkout-create-account';
import './components/scrollbar';
import './components/shop'
import './components/timeslot_datepicker'

jQuery(function ($) {
    $('.preloader').fadeOut()

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    })

    if ($('.show_monthy').length) {
        $('.show_monthy').hide();
    }
    if ($('#checkbox').prop('checked')) {
        $('.show_monthy').show();
    }

    $('#show-register').click(function (e) {
        e.preventDefault();
        e.stopPropagation();

        $('#login-form').addClass('d-none');
        $('#register-form').removeClass('d-none');
    });

    $('#show-login').click(function (e) {
        e.preventDefault();
        e.stopPropagation();

        $('#login-form').removeClass('d-none');
        $('#register-form').addClass('d-none');
    });

    $(document).ready(function () {
        $("#msgSuccess").hide();
        $("#msgError").hide();
        $("#msgStore").hide();
        $('#guestlist').click(function(e) {
            const guestlistEventId = $('#guestlist').data('event');
            let data = [{
                name:"route",
                value:$('#guestlistValue').val()
            },{
                name:"email",
                value:$('#email').val()
            },{
                name:"phone",
                value:$('#phone').val()
            },{
                name:"phone_code",
                value:$('#phone_code').val()
            },{
                name:"first_name",
                value:$('#first_name').val()
            },{
                name:"last_name",
                value:$('#last_name').val()
            }];
            $.ajax({
                type: "get",
                url: '/frame/shop/' + guestlistEventId + '/guestlist',
                data: { data },
                success: function (e) {
                    // Vervang de button
                    if(e.store === false) {
                        $("#guestlist").text("Signed up");
                    } else {
                        $("#guestlist").text("Remove from guestlist");
                    }

                    if (e.success === true) {
                        $("#msgSuccess").show();
                        $("#msgSuccess").html(e.message);
                        $("#msgSuccess").fadeOut(4000);
                    } else {
                        $("#msgError").show();
                        $("#msgError").html(e.message);
                        $("#msgError").fadeOut(4000);
                    }
                }, error: function (e) {

                },
            });
        });
    });
    $(document).ready(function () {
        $("#msgSuccess").hide();
        $("#msgError").hide();
        $("#msgStore").hide();
        $('#interest').click(function(e) {
            const interestEventId = $('#interest').data('event');
            let data = [{
                name:"route",
                value:$('#interestValue').val()
            },{
                name:"email",
                value:$('#email').val()
            },{
                name:"phone",
                value:$('#phone').val()
            },{
                name:"phone_code",
                value:$('#phone_code').val()
            },{
                name:"first_name",
                value:$('#first_name').val()
            },{
                name:"last_name",
                value:$('#last_name').val()
            }];
            $.ajax({
                type: "get",
                url: '/frame/shop/' + interestEventId + '/interest',
                data: { data },
                success: function (e) {
                    // Vervang de button
                    if(e.store === false) {
                        $("#interest").text("I'm Interested!");
                    } else {
                        $("#interest").text("Not Interested!");
                    }

                    if (e.success === true) {
                        $("#msgSuccess").show();
                        $("#msgSuccess").html(e.message);
                        $("#msgSuccess").fadeOut(4000);
                    } else {
                        $("#msgError").show();
                        $("#msgError").html(e.message);
                        $("#msgError").fadeOut(4000);
                    }
                }, error: function (e) {

                },
            });
        });
        $('#paid_private_interest_form').submit(function(e) {
            e.preventDefault()
            const interestEventId = $('#paid_private_interest_form_submit').data('event');
            let data = $(this).serializeArray();
            $.ajax({
                type: "get",
                url: '/frame/shop/' + interestEventId + '/interest',
                data: {data},
                success: function (e) {
                    if (e.store) {
                        $("#msgStore").show();
                        $("#msgStore").html(e.message);
                        $("#msgStore").fadeOut(4000);
                        $('#privateEventModal').modal('hide');
                    } else if (e.success === true) {
                        $("#msgSuccess").show();
                        $("#msgSuccess").html(e.message);
                        $("#msgSuccess").fadeOut(4000);
                    } else {
                        $("#msgError").show();
                        $("#msgError").html(e.message);
                        $("#msgError").fadeOut(4000);
                    }
                },
                error: function (e) {
                    for(let key in e.responseJSON.errors) {
                        $('#interest_form input[name="' + key + '"]').addClass('border-danger')
                        $('#interest_form input[name="' + key + '"]').parent().append(`<div class="validation_errors"><p class="text-danger mt-2"><i data-feather="alert-circle"></i>${e.responseJSON.errors[key][0]}</p></div>`)
                    }
                    $("#msg").html(e.message);
                    $("#msg").fadeOut(2000);
                },
            });
        });

    });

    $('.increaseTicket').click(function (e) {
        e.preventDefault()
        var ticketHolder = $(this).closest('.event-block')
        var ticketAmountHolder = ticketHolder.find('.ticket_amount')
        var ticketAmount = parseFloat(ticketHolder.data('amount'))
        var available = parseFloat(ticketHolder.data('available'))
        var max = parseFloat(ticketHolder.data('max'))
        var amountInput = ticketAmountHolder.parent().find('input')
        if (available > ticketAmount && isNaN(max) ? true : ticketAmount <= max) {
            ticketAmount++
            amountInput.val(ticketAmount)
            ticketAmountHolder.text(ticketAmount)
            ticketHolder.data('amount', ticketAmount)
            updateTicketTotal()
        } else {
            var maxpopup = ticketAmountHolder.parent().find('.max_tickets')
            if (!maxpopup.is(':visible')) {
                maxpopup.fadeIn()

                setTimeout(function () {
                    maxpopup.fadeOut()
                }, 2000)
            }
        }
    })

    $('.decreaseTicket').click(function (e) {
        e.preventDefault()
        var ticketHolder = $(this).closest('.event-block')
        var ticketAmountHolder = ticketHolder.find('.ticket_amount')
        var ticketAmount = parseFloat(ticketHolder.data('amount'))
        var max = parseFloat(ticketHolder.data('max'))
        var min = parseFloat(ticketHolder.data('min'))
        var amountInput = ticketAmountHolder.parent().find('input')
        if (ticketAmount > 0) {
            ticketAmount--
            amountInput.val(ticketAmount)
            ticketAmountHolder.text(ticketAmount)
            ticketHolder.data('amount', ticketAmount)

            if (ticketAmount < min) {
                amountInput.val(0)
                ticketAmountHolder.text(0)
                ticketHolder.data('amount', 0)
            }
        }
        updateTicketTotal()
    })
    //Currency symbol nawid
    const currencysym = [];
    currencysym['EUR']= "€";
    currencysym['USD']= "$";
    currencysym['GBP']= "£";

    function updateTicketTotal() {
        var total = 0
        var subtotal = 0
        var pre_total = 0
        var total_service = 0
        var total_amount = 0
        var discount_value = 0;
        var discount = parseFloat($('#payment_form').data('discount'));
        var discount_array = ($('#payment_form').data('discount-array'))
        var ticket = ($('#payment_form').data('ticket-array'))
        var monthtermijn1 = 0;
        var ticketAmount = ($('#payment_form').data('amount-ticket'))

        var tickets = [];
        var tA = [];
        var check_termijn = null;
        var discountpercent = 0

        if (isNaN(discount)) {
            discount = 0;
        }

        const currency = $('#ticket_total').data('currency')


        $('.event-block').each(function (index) {
            var monthtermijn = $(this).data('months')
            check_termijn = monthtermijn;
            var price = $(this).data('price')
            var firstInstallment = $(this).data('firstinstallment')
            var amount = $(this).data('amount')
            var servicekosten = $(this).data('service')
            var transactie = $(this).data('transactie')
            tickets[index] = $(this).data('tickets')
            tA[index] = $(this).data('amount')
            let bedrag = ((price * amount) / monthtermijn);
            if(firstInstallment) {
                bedrag = ((price - firstInstallment) * amount) / (monthtermijn - 1)
            }
            if (bedrag > 0) {
                $(this).find('.monthly_cost .cost').html(bedrag.toFixed(2))
                $(this).find('.monthly_cost .termijnen').html( (firstInstallment ? (firstInstallment * amount + ' + ' + (monthtermijn - 1)) : (monthtermijn)) + 'x' )
            } else {
                $(this).find('.monthly_cost .cost').html('')
                $(this).find('.monthly_cost .termijnen').html('')
            }

            if (servicekosten < 0.00) {
                servicekosten = 3
            }
            if (transactie) {
                price = price / 100 * 103.4
            }

            total += (price * amount)
            total_amount += amount
            total += (servicekosten * amount)
            total_service += (servicekosten * amount)
            pre_total += price * amount
            monthtermijn1 += firstInstallment ? (firstInstallment * amount) : bedrag

        })

        if (total_amount > 0) {
            $('#event_checkout').prop('disabled', false)
            $('#event_checkout_2').prop('disabled', false)
            $('#discount_btn').prop('disabled', false)
        } else {
            $('#event_checkout').prop('disabled', true)
            $('#event_checkout_2').prop('disabled', true)
            $('#discount_btn').prop('disabled', true)
        }
        var transactie = $('#payment_form').attr('data-transactie');
        if (discount !== 0) {
            var count = 0;
            var discount_type = $('#payment_form').attr('data-discount-type').toString()



            if (discount_type === 'percentage') {
                if (discount_array['discount_lvl'] === 1) {
                    var price = ticket['price'];
                    var dis = discount_array['discount_value'];
                    tickets.forEach(function (t) {
                        if ((t['ticket_type'] === ticket['ticket_type'] && t['id'] === discount_array['ticket_id']) ||
                            (discount_array['ticket_id'] === null && discount_array['organisation_id'] === t['organisation_id']) && t['ticket_type'] === discount_array['ticket_type']) {
                            discount_value += (t['price'] / 100) * dis;
                        }
                    })

                    if (transactie) {
                        pre_total = (pre_total / 100) * 103.4;
                        total = ((total - total_service) / 100 * 103.4 + total_service);
                    } else {
                        pre_total = price - discount_value;
                    }

                    total = total - discount_value;
                    discount = dis;
                    $('.ticket_discount').html(discount.toFixed(2) + '%');
                    $('.ticket_discount_value').html(currencysym[currency] + ' ' + discount_value.toFixed(2).toString().replace(".", ","))
                    $('.ticket_subtotal_price').html(currencysym[currency] + ' ' + pre_total.toFixed(2).toString().replace(".", ","))
                    $('.ticket_total_price').html(currencysym[currency] + '  ' + total.toFixed(2).toString().replace(".", ","))
                    $('.ticket_total_service').html(currencysym[currency] + ' ' + total_service.toFixed(2).toString().replace(".", ","))



                } else if (discount_array['discount_lvl'] === 3) {

                    price = ticket['price'];
                    dis = discount_array['discount_value'];


                    tickets.forEach(function (t) {

                        if (t['ticket_type'] === ticket['ticket_type'] && t['id'] === discount_array['ticket_id']) {
                            discount_value = (t['price'] / 100) * dis * tA[count];
                        }
                        count++
                    })
                    if (transactie) {
                        pre_total = (pre_total / 100) * 103.4;
                        total = ((total - total_service) / 100 * 103.4 + total_service);
                    }
                    total = total - discount_value;
                    discount = dis;
                    $('.ticket_discount').html(discount.toFixed(2) + '%');
                    $('.ticket_discount_value').html(currencysym[currency] + ' ' + discount_value.toFixed(2).toString().replace(".", ","))
                    $('.ticket_subtotal_price').html(currencysym[currency] + ' ' + pre_total.toFixed(2).toString().replace(".", ","))
                    $('.ticket_total_price').html(currencysym[currency] + '  ' + total.toFixed(2).toString().replace(".", ","))
                    $('.ticket_total_service').html(currencysym[currency] + ' ' + total_service.toFixed(2).toString().replace(".", ","))

                } else {

                    tickets.forEach(function (t) {

                        if (t['ticket_type'] === ticket['ticket_type']) {
                            count += ticketAmount
                            discount_value += (t['price'] / 100 * discount * ticketAmount)
                        }
                    })
                    if (transactie) {
                        pre_total = (pre_total / 100) * 103.4;
                        total = ((total - total_service) / 100 * 103.4 + total_service);
                    }
                    pre_total = pre_total - discount_value
                    total = total - discount_value


                    $('.ticket_discount').html(discount.toFixed(2) + '%');
                    $('.ticket_discount_value').html(currencysym[currency] + ' ' + discount_value.toFixed(2).toString().replace(".", ","))
                    $('.ticket_total_price').html(currencysym[currency]  + ' ' + total.toFixed(2).toString().replace(".", ","))
                    $('.ticket_total_service').html(currencysym[currency] + ' ' + total_service.toFixed(2).toString().replace(".", ","))
                    $('.ticket_subtotal_price').html(currencysym[currency] + ' ' + pre_total.toFixed(2).toString().replace(".", ","))
                }
            } else {

                if (discount_array['discount_lvl'] === 1 || discount_array['discount_lvl'] === 3) {
                    discount = discount_array['discount_value']
                    if (transactie) {
                        pre_total = (pre_total / 100) * 103.4;
                        total = ((total - total_service) / 100 * 103.4 + total_service);
                    }
                    total -= discount;


                    $('.ticket_discount').html(currencysym[currency]+ ' ' + discount.toFixed(2).toString().replace(".", ","))
                    $('.ticket_total_price').html(currencysym[currency] + ' ' + total.toFixed(2).toString().replace(".", ",")+"&nbsp; <i class=ti-shopping-cart></i>")
                    $('.ticket_total_service').html(currencysym[currency] + ' ' + total_service.toFixed(2).toString().replace(".", ","))
                    $('.ticket_subtotal_price').html(currencysym[currency] + ' ' + pre_total.toFixed(2).toString().replace(".", ","))

                } else {
                    if (transactie) {
                        pre_total = (pre_total / 100) * 103.4;
                        total = ((total - total_service) / 100 * 103.4 + total_service);
                    }
                    total -= discount;
                    $('.ticket_discount').html(currencysym[currency]+ ' ' + discount.toFixed(2).toString().replace(".", ","))
                    $('.ticket_total_price').html(currencysym[currency] + ' ' + total.toFixed(2).toString().replace(".", ",")+"&nbsp; <i class=ti-shopping-cart></i>")
                    $('.ticket_total_service').html(currencysym[currency] + ' ' + total_service.toFixed(2).toString().replace(".", ","))
                    $('.ticket_subtotal_price').html(currencysym[currency] + ' ' + pre_total.toFixed(2).toString().replace(".", ","))
                }


            }
        } else {
            if (transactie) {
                pre_total = (pre_total / 100) * 103.4;
                total = ((total - total_service) / 100 * 103.4 + total_service);
            }


            $('.ticket_total_price').html(currencysym[currency] + ' ' + total.toFixed(2).toString().replace(".", ",")+"&nbsp; <i class=ti-shopping-cart></i>")
            $('.ticket_total_service').html(currencysym[currency] + ' ' + total_service.toFixed(2).toString().replace(".", ","))
            $('.ticket_subtotal_price').html(currencysym[currency] + ' ' + pre_total.toFixed(2).toString().replace(".", ","))
            $('.total_monthly_cost').html(currencysym[currency] + ' ' + monthtermijn1.toFixed(2).toString().replace(".", ","))
        }


    }

    if ($('#payment_form').length) {
        updateTicketTotal()
    }

    $('a.paymentMethod').click(function (e) {
        if ($(this).data('type') === 'ideal') {
            e.preventDefault()
            $('#issuers').show()
            $(this).addClass('selected')
        } else {
            $('#issuers').hide()
            $('#mollie_methods a').removeClass('selected')
        }
    })
    var shop_id = location.href.split('/')[5]
    const reservedTxt = $('meta[name="reserved_txt"]').attr('content');
    if ($('#expiretime').length) {
        var expiretime = $('#expiretime').data('expire')
        var remain = getTimeRemaining(expiretime)
        $('#expiretime').html('<i id="expire-icon"></i><span>' + remain.minutes + ':' + remain.seconds + '</span>')
        var timer = setInterval(function () {
            var remain = getTimeRemaining(expiretime)

            if (parseFloat(remain.minutes) <= 0 && parseFloat(remain.seconds) <= 0) {
                clearInterval(timer)
                location.href = '/frame/shop/' + shop_id + '/checkout/expired'
                return
            }

            $('#expiretime span').html(remain.minutes + ':' + remain.seconds)
        }, 1000)
        $('#expire-icon').addClass('ti-time mr-2 ml-2')
    }

    function zeroFill(num) {
        if (num < 0) {
            return 0
        }
        var len = 2
        return '0'.repeat(len - num.toString().length) + num

    }

    function getTimeRemaining(endtime) {
        var t = Date.parse(new Date(endtime)) - Date.parse(new Date())
        var seconds = Math.floor((t / 1000) % 60)
        var minutes = Math.floor((t / 1000 / 60) % 60)
        var hours = Math.floor((t / (1000 * 60 * 60)) % 24)
        var days = Math.floor(t / (1000 * 60 * 60 * 24))
        return {
            'total': t,
            'days': days,
            'hours': hours,
            'minutes': zeroFill(minutes),
            'seconds': zeroFill(seconds),
        }
    }

    $('.discount-form button').click(function (e) {
        e.preventDefault();

        const discount_code = $('input[name="discount_code"]').val() || $('input[name="discount_code_mobile"]').val();
        console.log({discount_code})
        const post_url = $(this).parent().data('url');

        $.ajax({
            type: "POST",
            url: post_url,
            data: { discount_code },
            success: function (e) {
                window.location.reload();
            }, error: function (e) {
                $('.discount_error').html('<div class="alert alert-danger">The discount code is not valid. </div>')
                $('.discount_error').parent().find('.fa-spinner').remove()
            },
            dataType: 'json'
        });
    })

    $(document).ready(function () {
        $(document).on('change', '#termijn', function () {
            const termijn = $('input[type="checkbox"]').val();
            const event = $('#termijn').data('event');
            const shop = $('#termijn').data('shop');
            if ($('#checkbox').is(":checked")) {
                $.ajax({
                    type: 'get',
                    url: 'frame/shop/' + shop + '/event/' + event,
                    data: { 'checkbox': 'true', 'organisation_id': shop, 'event_id': event },
                    success: function (data) {
                        $('#html').replaceWith(data);
                        $('#checkbox').prop('checked', true);

                    }, error: function (jqXHR, textStatus, errorThrown) {
                        $("#error").html();
                    },
                });
            } else {
                $.ajax({
                    type: 'get',
                    url: 'frame/shop/' + shop + '/event/' + event,
                    data: { 'checkbox': 'false', 'organisation_id': shop, 'event_id': event },
                    success: function (data) {
                        location.reload();
                    }, error: function (jqXHR, textStatus, errorThrown) {
                        $("#error").html();
                    },
                });

            }
        });
    });

    // Prullenbak-functionaliteit
    $(document).on('click', '.remove-ticket', function (e) {
        e.preventDefault();
        var ticketHolder = $(this).closest('.event-block');
        var ticketAmountHolder = ticketHolder.find('.ticket_amount');
        var amountInput = ticketAmountHolder.parent().find('input');
        ticketAmountHolder.text(0);
        amountInput.val(0);
        ticketHolder.data('amount', 0);
        $(this).hide();
        if (typeof updateTicketTotal === 'function') updateTicketTotal();
    });
    // Toon/verberg prullenbak afhankelijk van aantal
    function updateRemoveButtons() {
        $('.event-block').each(function () {
            var amount = parseInt($(this).data('amount'));
            if (amount > 0) {
                $(this).find('.remove-ticket').show();
            } else {
                $(this).find('.remove-ticket').hide();
            }
        });
    }
    // Koppel aan bestaande ticket-functies
    $('.increaseTicket, .decreaseTicket').on('click', function () {
        setTimeout(updateRemoveButtons, 100);
    });
    $(document).ready(function () {
        updateRemoveButtons();
    });
})
